if (!customElements.get('snazzy-tab')) {
  class SnazzyTab extends HTMLElement {
    connectedCallback() {
      this.tabButtons = [...this.querySelectorAll('.snazzy-tab-button')];
      this.tabContents = [...this.querySelectorAll('.snazzy-tab-content')];

      this.setupAccessibility();

      this.addEventListener('click', (event) => {
        const clickedButton = event.target.closest('.snazzy-tab-button');
        const index = this.tabButtons.indexOf(clickedButton);

        if (index !== -1) {
          this.updateTabs(index);
          clickedButton.focus();
        }
      });

      this.addEventListener('keydown', (event) => {
        const currentButton = event.target.closest('.snazzy-tab-button');
        const currentIndex = this.tabButtons.indexOf(currentButton);

        if (currentIndex === -1) return;

        let nextIndex = currentIndex;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.updateTabs(currentIndex);
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          nextIndex = (currentIndex + 1) % this.tabButtons.length;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          nextIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
        }

        if (nextIndex !== currentIndex) {
          this.updateTabs(nextIndex);
          this.tabButtons[nextIndex].focus();
        }
      });
    }

    setupAccessibility() {
      this.tabButtons.forEach((button, index) => {
        const isActive = button.classList.contains('active');

        button.setAttribute('role', 'tab');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');

        if (!button.id) {
          button.id = `snazzy-tab-${index + 1}`;
        }

        const panel = this.tabContents[index];

        if (panel) {
          if (!panel.id) {
            panel.id = `snazzy-tab-panel-${index + 1}`;
          }

          button.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', button.id);
          panel.hidden = !isActive;
        }
      });
    }

    updateTabs(index) {
      this.tabButtons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === index;

        button.classList.toggle('active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.tabContents.forEach((content, contentIndex) => {
        const isActive = contentIndex === index;

        content.classList.toggle('active', isActive);
        content.hidden = !isActive;
      });
    }
  }

  customElements.define('snazzy-tab', SnazzyTab);
}